import styled from 'styled-components';
import { Color } from '../Globals/Globals';

interface IFlexInterface {
  color?: Color;
}

const Button = styled.button<IFlexInterface>`
  color: ${Color.white};
  background-color: ${props => props.color || Color.darkBlue};
  padding: 9px 20px;
  width: fit-content;
  border-radius: 8px;
  cursor: pointer;
`;

const BackButton = styled(Button)`
  color: ${Color.darkBlue};
  border: ${Color.darkBlue} solid 2px;
  background: none;
  align-self: center;
  border-radius: 0;
  padding-left: 5em;
  padding-right: 5em;
  font-weight: 600;
`;

export { Button, BackButton };



// WEBPACK FOOTER //
// ./src/components/Button/Button.tsx